import axios from "axios";
import { Offer } from "@/types/offer";
import { API_URL_OFFERS } from "@/constants/EngineConstants";
import { OfferParams } from "@/types/offerParams";
import { Ubigeo } from "@/types/ubigeo";

export const getOffers = async (
  params: OfferParams
): Promise<Offer[]> => {
  const { data } = await axios.get<Offer[]>(`${API_URL_OFFERS}/all`, {
    params
  });
  return data;
};

export const getOrgins = async (params: OfferParams): Promise<Ubigeo[]> => {
  const { data } = await axios.get<Ubigeo[]>(`${API_URL_OFFERS}/origins`, {
    params
  });
  return data;
};

export const getMostSearched = async (params: OfferParams): Promise<Offer[]> => {
  const { data } = await axios.get<Offer[]>(`${API_URL_OFFERS}/most-searched`, {
    params
  });
  return data;
};